// 1. utils/slugify.ts dosyası
export const slugify = (text: string): string => {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .trim()
    // Türkçe karakterleri dönüştür
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    // Özel karakterleri kaldır
    .replace(/[^\w\s-]/g, '')
    // Boşluk ve alt çizgileri tire ile değiştir
    .replace(/[\s_-]+/g, '-')
    // Başta ve sondaki tireleri kaldır
    .replace(/^-+|-+$/g, '');
};

// Slug'dan title'a geri dönüştürme (isteğe bağlı)
export const unslugify = (slug: string): string => {
  if (!slug) return '';
  
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// URL validation için yardımcı fonksiyon
export const isValidSlug = (slug: string): boolean => {
  const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  return slugRegex.test(slug);
};
